/* reveal on scroll */
(function(){var els=document.querySelectorAll('.reveal');if(!('IntersectionObserver'in window)){els.forEach(function(e){e.classList.add('in');});return;}
var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('in');io.unobserve(x.target);}});},{threshold:.1,rootMargin:'0px 0px -6% 0px'});els.forEach(function(e){io.observe(e);});setTimeout(function(){els.forEach(function(e){e.classList.add('in');});},2600);})();

/* FAQ accordion */
(function(){document.querySelectorAll('.faq-item').forEach(function(it){var q=it.querySelector('.faq-q'),a=it.querySelector('.faq-a');q.addEventListener('click',function(){var open=it.classList.contains('open');document.querySelectorAll('.faq-item.open').forEach(function(o){o.classList.remove('open');o.querySelector('.faq-a').style.maxHeight=null;});if(!open){it.classList.add('open');a.style.maxHeight=a.scrollHeight+'px';}});});})();

/* GA4 helper (safe if gtag/dataLayer absent) */
function sbTrack(ev,params){try{window.dataLayer=window.dataLayer||[];window.dataLayer.push(Object.assign({event:ev},params||{}));}catch(e){}}
/* CTA click tracking */
document.querySelectorAll('[data-cta]').forEach(function(el){el.addEventListener('click',function(){sbTrack('commercial_cta_click',{cta_location:el.getAttribute('data-cta')});});});

/* attribution capture */
(function(){try{var p=new URLSearchParams(location.search);['utm_source','utm_medium','utm_campaign','utm_term','utm_content'].forEach(function(k){var el=document.getElementById(k);if(el)el.value=p.get(k)||'';});var u=document.getElementById('page_url');if(u)u.value=location.href;var r=document.getElementById('referrer');if(r)r.value=document.referrer||'';}catch(e){}})();

/* multi-step form */
(function(){
  var form=document.getElementById('cform');if(!form)return;

  /* ===========================================================
     LAUNCH BLOCKER — set ENDPOINT to the VERIFIED GHL inbound
     webhook URL to enable live submission. While it is empty the
     form NEVER shows a success state: it tells the user to call or
     email instead. 'commercial_lead_success' fires ONLY after the
     backend confirms the lead was persisted (HTTP 2xx response).
     =========================================================== */
  var ENDPOINT='';

  var subs=['What needs cleaning?','Where & when?','Your details'];
  var started=false;
  function showStep(n){
    form.querySelectorAll('.fstep').forEach(function(s){s.classList.toggle('active',s.getAttribute('data-step')==String(n));});
    form.querySelectorAll('.fstep-ind i').forEach(function(i){i.classList.toggle('on',Number(i.getAttribute('data-s'))<=n);});
    document.getElementById('fsub').textContent='Step '+n+' of 3 · '+subs[n-1];
    form.scrollIntoView({behavior:'smooth',block:'start'});
  }
  function err(id,show){var e=document.getElementById('err-'+id);if(e)e.classList.toggle('show',show);var f=form.querySelector('[name="'+id+'"]');if(f&&f.classList)f.classList.toggle('invalid',show);}
  function validateStep(n){
    var ok=true;
    if(n==1){
      var svc=form.querySelectorAll('input[name="services"]:checked').length>0;err('services',!svc);if(!svc)ok=false;
      var pt=form.querySelector('[name="property_type"]').value.trim();err('property_type',!pt);if(!pt)ok=false;
    }
    if(n==2){
      ['postcode','frequency'].forEach(function(k){var v=form.querySelector('[name="'+k+'"]').value.trim();err(k,!v);if(!v)ok=false;});
    }
    if(n==3){
      ['contact_name','company','phone'].forEach(function(k){var v=form.querySelector('[name="'+k+'"]').value.trim();err(k,!v);if(!v)ok=false;});
      var em=form.querySelector('[name="email"]').value.trim();var emok=/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em);err('email',!emok);if(!emok)ok=false;
      var c=form.querySelector('[name="consent"]').checked;err('consent',!c);if(!c)ok=false;
    }
    return ok;
  }
  form.addEventListener('input',function(){if(!started){started=true;sbTrack('commercial_form_start');}});
  form.querySelectorAll('[data-next]').forEach(function(b){b.addEventListener('click',function(){var cur=Number(b.closest('.fstep').getAttribute('data-step'));if(validateStep(cur))showStep(Number(b.getAttribute('data-next')));});});
  form.querySelectorAll('[data-prev]').forEach(function(b){b.addEventListener('click',function(){showStep(Number(b.getAttribute('data-prev')));});});

  form.addEventListener('submit',function(e){
    e.preventDefault();
    if(!validateStep(3))return;
    if(form.querySelector('[name="company_website"]').value){return;} /* honeypot: silently drop bots */
    var notice=document.getElementById('submitNotice');notice.classList.remove('show');
    var meta=Array.prototype.map.call(form.querySelectorAll('input[name="services"]:checked'),function(i){return i.value;}).join(', ');
    document.getElementById('service_metadata').value=meta;
    sbTrack('commercial_form_submit',{services:meta,property_type:form.querySelector('[name="property_type"]').value});
    var btn=document.getElementById('submitBtn');var label=btn.innerHTML;btn.disabled=true;btn.textContent='Sending…';
    function fail(){btn.disabled=false;btn.innerHTML=label;notice.classList.add('show');notice.scrollIntoView({behavior:'smooth',block:'center'});}
    function success(){
      form.querySelectorAll('.fstep,.fnav').forEach(function(s){s.style.display='none'});
      form.querySelector('.fcard-hd').style.display='none';document.getElementById('fsub').style.display='none';
      document.getElementById('fsuccess').classList.add('show');
      sbTrack('commercial_lead_success',{services:meta}); /* fires ONLY on confirmed persistence */
    }
    /* No verified endpoint wired yet → never fake a success */
    if(!ENDPOINT){fail();return;}
    fetch(ENDPOINT,{method:'POST',body:new FormData(form)}).then(function(r){if(!r.ok)throw 0;success();}).catch(function(){fail();});
  });
})();